/**
 * 시스템 > 동기화 현황 > 동기화 설정 Store
 *
 * @since 2018-10-10
 * @author devp018
 */
import { SystemApiPrefix as apiPrefix } from '~/utils/restApi'

const initSyncConfig = () => {
  return {
    'sync.except.dow_sun_yn': '0',
    'sync.except.dow_mon_yn': '0',
    'sync.except.dow_tue_yn': '0',
    'sync.except.dow_wed_yn': '0',
    'sync.except.dow_thu_yn': '0',
    'sync.except.dow_fri_yn': '0',
    'sync.except.dow_sat_yn': '0',
    'sync.except.start_hour': '01',
    'sync.except.start_min': '10',
    'sync.except.end_hour': '18',
    'sync.except.end_min': '00',
    'sync.settings.enable_yn': '1'
  }
}

export const state = () => ({
  configUrl: `${apiPrefix}/sync/config`, // 동기화 설정 조회 API
  syncConfig: initSyncConfig(),
  syncDurations: []
})

export const mutations = {
  initSyncData (state) {
    state.syncConfig = initSyncConfig()
    state.syncDurations = []
  },
  setSyncConfig (state, data) {
    _.forEach(data, config => {
      state.syncConfig[config['key']] = config['val']
    })
  },
  setSyncDurations (state, data) {
    state.syncDurations = data
  }
}

export const actions = {
  // 동기화 설정 조회
  async getSyncData ({commit, state}, isLoading = true) {
    const res = await this.$axios.$get(state.configUrl, {loading: isLoading})
    if (res.code === 'ok') {
      commit('setSyncConfig', res.result['sync_config'])
      commit('setSyncDurations', res.result['sync_durations'])
    }
    return res
  },
  // 동기화 설정 적용
  async applySyncData ({commit, state}) {
    const params = {
      sync_config: [],
      sync_durations: state.syncDurations
    }

    _.forEach(state.syncConfig, (confVal, confKey) => {
      params.sync_config.push({
        key: confKey,
        val: confVal
      })
    })

    const res = await this.$axios.$put(state.configUrl, params, {loading: true, successAlert: false})

    return res
  },
  async finalCommand ({commit, state}, type) {
    const axiosConfig = (type === 'apply') ? { applyMsg: true } : { cancelMsg: true }
    const res = await this.$axios.$put(`${state.configUrl}/${type}`, void 0, axiosConfig)

    return res
  }
}

export const getters = {}

export const strict = false
